/**
 * RevenueCat Web Billing Configuration
 * Public API key for web purchases - safe to include in client code
 */

export const REVENUECAT_CONFIG = {
  // Web Billing Public API Key (production)
  publicApiKey: 'rcb_ovhcLmBLoGvjOUuFzLtcVGQrRlZS',

  // Sandbox key for testing (staging + local dev)
  sandboxApiKey: 'rcb_sb_KfbjGUbdiOUYRvhHICOUmIATE',

  // Env-switched so ONLY a real prod build can touch live Web Billing. Any web
  // purchase that goes through RevenueCat (e.g. AccountSettingsModal →
  // purchasePackage → RC Billing checkout) therefore can't make a real charge on
  // staging or in dev. Prod build = NODE_ENV production AND not the staging env.
  apiKey: (process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENV !== 'staging')
    ? 'rcb_ovhcLmBLoGvjOUuFzLtcVGQrRlZS'   // production
    : 'rcb_sb_KfbjGUbdiOUYRvhHICOUmIATE',  // sandbox (staging / dev)
  
  // Entitlement identifiers (must match RevenueCat dashboard).
  // Premium was RETIRED on 2026-09-11 (owner): there is one plan, the APS
  // Membership (regular_access). `premium` stays ONLY so existing
  // premium_access grants in RevenueCat still read as active access — never
  // sell, offer or label it.
  entitlements: {
    regular: 'regular_access',
    premium: 'premium_access',
  },

  // Package identifiers in the default offering (single plan).
  packages: {
    regular: 'regular',
  },

  // Product features for display. Source of truth = the Aug-2026 pricing flyer
  // (KGH-785). The single APS Membership ($19.95/mo) lists what's INCLUDED; the
  // former white-glove services are à-la-carte (contact for pricing, see
  // ALACARTE_OPTIONS below).
  productFeatures: {
    regular: [
      'AI-powered school matching',
      'Access to 3,000+ verified college coaches',
      'Direct messaging via Gmail',
      'Social media integration',
      'YouTube channel setup',
      'Analytics dashboard',
      'Unlimited highlight video uploads',
    ],
  },
} as const;

// À-la-carte add-on services (KGH-785). These are NOT purchasable in-app —
// per the client we list them and route to email, explicitly so users don't try
// to add them to a cart (also keeps us clear of App Store IAP rules for
// off-platform services). Surfaced as an "Additional features available —
// contact for pricing" section below the plan card.
export const ALACARTE_OPTIONS = [
  'Monthly 1-on-1 coaching calls',
  '2-3 professional highlight videos per year',
  'Verified performance stats',
  'Priority support',
  'Advanced recruitment roadmap',
] as const;

// À-la-carte inquiry inbox (KGH-785, confirmed with Gaines).
export const ALACARTE_CONTACT_EMAIL = 'support@apsrecruits.com';

// Export individual config sections for easier imports
export const ENTITLEMENTS = REVENUECAT_CONFIG.entitlements;
export const PACKAGES = REVENUECAT_CONFIG.packages;
export const PRODUCT_FEATURES = REVENUECAT_CONFIG.productFeatures;
